import { Injectable } from '@angular/core';

import { isDate, isValid, parseISO } from 'date-fns';
import { format as dateFnsFormatter, utcToZonedTime } from 'date-fns-tz';
import enUS from 'date-fns/locale/en-US';
import enCA from 'date-fns/locale/en-CA';
import { isNil } from '../utils';

export const TIME_ZONES = {
  'Eastern Time (US & Canada)': 'America/New_York',
  'Indiana (East)': 'America/Indiana/Indianapolis',
  'Central Time (US & Canada)': 'America/Chicago',
  'Saskatchewan': 'America/Regina',
  'Mountain Time (US & Canada)': 'America/Denver',
  'Arizona': 'America/Phoenix',
  'Pacific Time (US & Canada)': 'America/Los_Angeles',
  'Alaska': 'America/Juneau',
  'Atlantic Time (Canada)': 'America/Halifax',
  'Newfoundland': 'America/St_Johns',
  'Hawaii': 'Pacific/Honolulu',
};

@Injectable({ providedIn: 'root' })
export class PhxDateFnsFormatter {
  private defaultLocale: Locale = enUS;

  private normalizeTimeZone(tz: string): string {
    const mappedTz: string = TIME_ZONES[tz];
    return mappedTz ? mappedTz : tz;
  }

  private mapTimeZoneToLocale(tz: string): Locale {
    const locale = this.defaultLocale;
    if (isNil(tz)) return locale;
    if (tz === TIME_ZONES.Newfoundland || tz === TIME_ZONES['Atlantic Time (Canada)'] || tz === TIME_ZONES.Saskatchewan) {
      return enCA;
    }
    return locale;
  }

  /**
   *
   * @param dateTime - Native date object or date string in ISO standard format
   * @param format - format string
   * @param timezone - timezone in string
   */
  public format(dateTime: Date | string | number, format: string, timezone?: string): string {
    let date: Date;
    if (typeof (dateTime) === 'string') date = parseISO(dateTime);
    else if (typeof (dateTime) === 'number') date = new Date(dateTime);
    else date = dateTime;

    if (!isDate(date) || !isValid(date) || isNil(dateTime)) return '';
    if (timezone && !isNaN(date.getTimezoneOffset())) {
      const userTimeZone: string = this.normalizeTimeZone(timezone);
      const timeZoneLocale = this.mapTimeZoneToLocale(userTimeZone);
      const utcZonedString: string = dateFnsFormatter(utcToZonedTime(date, userTimeZone), format, {
        timeZone: userTimeZone,
        locale: timeZoneLocale,
      });
      return utcZonedString;
    }
    return dateFnsFormatter(date, format);
  }
}